module.exports = __webpack_public_path__ + "15d7ed5cd0686448144c01d0baeca9c6.png";